import { RedirectLinkEntity } from "@client/content/controls/Link/Redirect/container";
import { getEntityRef } from "@client/content/lib/helper";
import { type ItemContainerProps } from "@client/content/types";
import * as React from "react";

export type ListsItemComponentProps = ItemContainerProps & {
  className: string;
  icon: string | null;
  title: string;
};

export default (props: ListsItemComponentProps) => (
  <div className={props.className}>
    {props.icon && <i className={props.icon} />}

    <RedirectLinkEntity className="link" {...getEntityRef(props)}>
      <props.TextComponent
        {...getEntityRef(props)}
        tag="span"
        toolbar={"basic"}
        prop="title"
        html={props.title}
        className="text_content"
      />
    </RedirectLinkEntity>
  </div>
);
